export default __webpack_public_path__ + "static/media/Group7557.850759b3.png";